export const MY_WORK_CLOSED_GROUPS_LOCALSTORAGE = 'MY_GROUPS_CLOSED_GROUPS_LOCALSTORAGE';
